import Stream from './recommendations/index';

export const Recommendations = Stream;
